var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',[(_vm.loader === false)?_c('debtor-edit-account',{staticClass:"mt-2 pt-75",attrs:{"user-data":_vm.userData,"form-data":_vm.formData}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }